import { Dispatch, FC, SetStateAction, useState } from "react";
import { useAppDispatch } from "redux/hooks";

import { resetMenu, resetStep } from "redux/slices/StepSlice";
import { ResetLogin } from "redux/slices/LoginSlice";
import { resetOtp } from "redux/slices/OtpSlice";
import { resetMerchant } from "redux/slices/MerchantSlice";
import { resetMerchantSwitch } from "redux/slices/MerchantSwitchSlice";
import { resetEmployeeManagement } from "redux/slices/EmployeeManagementSlice";
import { resetAuthList } from "redux/slices/AuthListSlice";
import { resetEmployee } from "redux/slices/EmployeeSlice";

import Button from "../../BaseComponents/Button";
import Modal from "../../BaseComponents/Modal";

import { Col, Row, Seperator } from "../../BaseComponents/Flex";

import { useMediaQuery } from "context/media/MediaContext";
import { Logout } from "services/logout.service";
import { useNavigate } from "react-router-dom";
import { TokenInclude } from "helpers/GetToken";
import { resetServiceError } from "redux/slices/ServiceInlineError";
import Spinner from "components/BaseComponents/Spinner";

interface LogoutModalProps {
  title?: string;
  message?: string;
  acceptButtonText?: string;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  rejectButtonText?: string;
}

const LogoutModal: FC<LogoutModalProps> = ({
  title,
  message,
  acceptButtonText,
  rejectButtonText,
  setIsOpen,
}) => {
  const navigate = useNavigate();
  const { isMobile } = useMediaQuery();
  const dispatch = useAppDispatch();

    const [isLoading, setIsLoading] = useState(false);

  const token = TokenInclude();
  const onAcceptClick = async () => {
    setIsLoading(true);
    const result = await Logout(token);

    if (result) {
      dispatch(resetStep());
      dispatch(ResetLogin());
      dispatch(resetOtp());
      dispatch(resetMerchant());
      dispatch(resetMerchantSwitch());
      dispatch(resetEmployeeManagement());
      dispatch(resetAuthList());
      dispatch(resetEmployee());
      dispatch(resetMenu());
      dispatch(resetServiceError());
      setIsOpen(false);
      setIsLoading(false);
      navigate("/");
    } else {
      setIsLoading(false);
      setIsOpen(false);
      window.location.reload();
    }
  };

  const onRejectClick = (): void => setIsOpen(false);

  return (
  <>
    <Modal info={message} maxWidth={450} setIsOpen={setIsOpen} title={title}>
      <Row justifyContent='center' isResponsive noMargin>
        <Col size={0.3}>
          <Button
            color='light'
            onClick={onAcceptClick}
            text={acceptButtonText}
            />
        </Col>

        <Seperator marginRight={20} marginTop={isMobile ? 10 : 0} />

        <Col size={0.3}>
          <Button onClick={onRejectClick} text={rejectButtonText} />
        </Col>
      </Row>
    </Modal>
    <Spinner show={isLoading} />
  </>
  );
};

export default LogoutModal;
